module.exports = __webpack_public_path__ + "img/kf2.61d7f258.png";